import { green, grey, orange } from '@mui/material/colors';
import { Box, Button, css, Paper, styled } from '@mui/material';

import { IBaseTableStyles } from '/shared/Table/interfaces/base/IBaseTableStyles';

import { IStyleProps } from './types';
import { HoverButtonProps, IResolvedColor } from './IssuesSupportRequests/types';
import { chooseResolveColor } from './helpers';

interface ServiceSectionProps {
  colums: boolean;
  disabled: boolean;
}

export const GlobalStyle = {
  display: 'grid',
  width: '100%',
  padding: '0 20px',
  border: `1px solid ${grey[300]}`,
  borderRadius: 3,
  cursor: 'pointer',
};

export const ServiceSection = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'colums' && prop !== 'disabled',
})<ServiceSectionProps>(({ theme, colums, disabled }) => ({
  ...GlobalStyle,
  maxWidth: '1280px',
  margin: '20px 0px',
  height: '65px',
  display: 'grid',
  gridTemplateColumns: colums ? 'repeat(2, 1fr)' : 'unset',
  pointerEvents: disabled ? 'none' : 'auto',
  opacity: disabled ? 0.5 : 1,
  [theme.breakpoints.down('sm')]: {
    margin: '16px',
    width: 'unset',
  },
}));

export const AttachmentPickerStyled = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: '29px',
  top: '67px',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const ButtonStyled = styled(Button)<HoverButtonProps>((props) => {
  const chooseColor = chooseResolveColor(props['aria-label']);
  const onHover = props.hovered && props['aria-label'] === IResolvedColor.RESOLVED ? orange[500] : green[500];

  return {
    color: chooseColor,
    borderColor: chooseColor,
    textTransform: 'capitalize',
    height: '30px',
    width: '85px',
    ...(props.disabled
      ? {}
      : {
          '&:hover': {
            borderColor: onHover,
            color: '#fff',
            backgroundColor: onHover,
          },
        }),
  };
});

export const MobileFooter = styled(Paper)`
  height: 120px;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 24px 10px 28px 10px;
  z-index: 100;
  border-radius: 0;
`;

const CELL_WITH_BIG_CONTENT_MAX_WIDTH = 110;
const MESSAGE_CELL_MAX_WIDTH = 200;
const META_CELL_WIDTH = 150;
const TAGS_CELL_WIDTH = 180;
const CELL_MIN_WIDTH = 0;
const CELL_MAX_WIDTH = 100;
export const MessageCellStyled = styled('div')({
  width: 'auto',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});

export const fieldIdCSS = css`
  width: 300px;
`;

export const fieldTypeCSS = css`
  width: fit-content;
`;

export const cellWithBigContentCSS = css`
  max-width: ${CELL_WITH_BIG_CONTENT_MAX_WIDTH}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const metaCellCSS = css`
  width: ${META_CELL_WIDTH}px;
`;
export const tagsCellCSS = css`
  width: ${TAGS_CELL_WIDTH}px;
`;
export const previewCellCSS = css`
  padding: 4px;
  width: ${CELL_MAX_WIDTH}px;
  img:hover {
    filter: blur(1px);
  }
`;

export const messageCellCSS = css`
  max-width: ${MESSAGE_CELL_MAX_WIDTH}px;
  cursor: pointer;
`;

export const statusCellCSS = css`
  white-space: nowrap;
`;

export const cellCSS = css`
  &:last-child {
    min-width: ${CELL_MIN_WIDTH}px;
    max-width: ${CELL_MAX_WIDTH}px;
  }
`;

export const tableWrapperCSS = css`
  width: 100%;
`;

export const toolbarAnyContainerCSS = ({ count = 0, isAttachments }: IStyleProps) => css`
  display: ${count > 0 || isAttachments ? 'none' : 'inline-flex'};
`;

export const toolbarColumnSelectionCSS = ({ count = 0, isAttachments }: IStyleProps) => css`
  display: ${count > 0 || isAttachments ? 'none' : 'inline-flex'};
`;

export const NoteCell = styled('div')`
  padding-left: 14px;
`;

export const tableStyles = ({ count = 0, isAttachments }: IStyleProps): IBaseTableStyles => ({
  cell: cellCSS,
  headerCell: cellCSS,
  tableWrapper: tableWrapperCSS,
  toolbarAnyContainer: toolbarAnyContainerCSS({ count, isAttachments }),
  toolbarColumnSelection: toolbarColumnSelectionCSS({ count, isAttachments }),
});
